module.exports = __webpack_public_path__ + "static/media/forgotpassword.6e731fc9.png";